var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoConstructora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_765",
    "data-name": "Group 765",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210.662,
    height: 97.016,
    viewBox: "0 0 210.662 97.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #002f5f;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #8abb2a;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #6d6f72;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #96999c;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #032f5e;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #005596;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    className: "cls-1",
    width: 210.662,
    height: 97.016
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_765-2",
    "data-name": "Group 765",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    className: "cls-3",
    d: "M21.9,229.237a12.684,12.684,0,0,1-9.145,3.575C3.816,232.812.035,226.658,0,220.4c-.034-6.291,4.056-12.685,12.754-12.685a12.415,12.415,0,0,1,8.836,3.679l-3.025,2.922a8.267,8.267,0,0,0-5.811-2.269c-5.81,0-8.319,4.331-8.285,8.353.034,3.988,2.338,8.148,8.285,8.148a8.861,8.861,0,0,0,6.051-2.441Z",
    transform: "translate(0 -135.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    className: "cls-3",
    d: "M85.792,233.172H67.779V209.108H85.792v4.4H72.282v5.535H85.311v4.228H72.282V228.7h13.51Z",
    transform: "translate(-44.333 -136.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    className: "cls-3",
    d: "M145.857,209.009h4.538v24.1h-2.819v.035l-12.651-16.261v16.226h-4.538V209.043h3.678l11.792,14.92Z",
    transform: "translate(-85.285 -136.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    className: "cls-3",
    d: "M201.128,213.233H193.5v-4.126h19.8v4.126h-7.632v19.939h-4.538Z",
    transform: "translate(-126.564 -136.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    "data-name": "Path 3092",
    className: "cls-3",
    d: "M277.419,233.108h-5.4l-7.013-8.044h-4.366v8.044h-4.538v-24.1c3.816,0,7.632.034,11.448.034,5.672.035,8.663,3.816,8.663,7.976,0,3.3-1.512,6.635-6.085,7.563l7.288,8.216Zm-16.776-19.836v7.7h6.91a3.86,3.86,0,1,0,0-7.7Z",
    transform: "translate(-167.516 -136.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    className: "cls-3",
    d: "M342.04,220.367c-.069,6.222-3.885,12.444-12.342,12.444s-12.376-6.085-12.376-12.411,4.056-12.685,12.376-12.685c8.285,0,12.41,6.36,12.342,12.651m-20.249.1c.1,3.954,2.234,8.182,7.906,8.182s7.8-4.263,7.873-8.216c.069-4.057-2.2-8.594-7.873-8.594s-8.01,4.572-7.906,8.629",
    transform: "translate(-207.557 -135.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    className: "cls-3",
    d: "M425.376,213.358a6.9,6.9,0,0,0-5.707-2.682c-3.369,0-4.985,1.41-4.985,3.2,0,2.1,2.476,2.681,5.363,3.025,5.019.619,9.694,1.925,9.694,7.666,0,5.363-4.744,7.666-10.107,7.666-4.915,0-8.7-1.513-10.485-5.913l3.782-1.96c1.066,2.647,3.85,3.816,6.773,3.816,2.853,0,5.534-1,5.534-3.61,0-2.269-2.372-3.2-5.569-3.541-4.916-.585-9.453-1.891-9.453-7.288,0-4.95,4.881-6.978,9.316-7.013,3.747,0,7.632,1.066,9.454,4.778Z",
    transform: "translate(-267.62 -135.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    className: "cls-3",
    d: "M497.24,209.207v13.785c0,7.116-4.365,10.76-10.416,10.76-5.775,0-10.691-3.506-10.691-10.76V209.207h4.5v13.785c0,4.332,2.475,6.635,6.223,6.635s5.878-2.51,5.878-6.635V209.207Z",
    transform: "translate(-311.433 -136.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    className: "cls-3",
    d: "M568.7,233.108h-5.4l-7.013-8.044h-4.366v8.044H547.39v-24.1c3.816,0,7.632.034,11.448.034,5.672.035,8.663,3.816,8.663,7.976,0,3.3-1.513,6.635-6.085,7.563L568.7,232.8Zm-16.776-19.836v7.7h6.91a3.859,3.859,0,1,0,0-7.7Z",
    transform: "translate(-358.042 -136.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    className: "cls-4",
    d: "M250.27,0l27.359,15.162-14.136,7.911-13.225-7.332-13.119,7.428-14.2-7.9Z",
    transform: "translate(-145.826 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    className: "cls-5",
    d: "M329.3,43.808,301.938,59.121v15.8L329.3,59.748Z",
    transform: "translate(-197.494 -28.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    className: "cls-6",
    d: "M250.265,59.338l-27.325-15.2,0,15.783,27.328,15.224Z",
    transform: "translate(-145.822 -28.872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    className: "cls-7",
    d: "M329.274,105.882,301.9,121.1l.014,14.941L329.275,120.8Z",
    transform: "translate(-197.467 -69.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    className: "cls-8",
    d: "M250.255,121.119,222.939,105.9l0,15.012,27.329,15.14Z",
    transform: "translate(-145.82 -69.271)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConstructora);
export default __webpack_public_path__ + "static/media/logo-constructora.cf8dbce39e3e4c8240caf77c0a50148a.svg";
export { ForwardRef as ReactComponent };